<!--Tree Table Component - 1.0.0
    Created : 10-SEP-2019
    Created By : SPR/860
    Modified : 03-Jan-2020
    Dependencies: VUE JS
    Use : Create a tree structure: Parent rows can have child rows, which in turn can have their own children, 
          Child rows can be collapsed and expanded.. -->
<template>
    <div v-if="card.type == 'TreeTable'" class="vue-ads-table-tree" v-bind:class="{ 'fixedHeader': (fixedHeader == true), 'non-searchable': (simpleSearch != true)}">
        <v-icon class="tree-table-simple-search" v-if="simpleSearch == true">mdi-magnify</v-icon>

        <!--Tree Table Component.-->
        <vue-ads-table :columns="headers"
                       :rows="formData"
                       :items-per-page="pagination.pageSize == -1 ? 100000 : pagination.pageSize"
                       :filter="_ttFilterValue"
                       @filter-change="_ttFilterChanged">

            <!--No Data Available.-->
            <template slot="no-rows">
                {{messages.noData}}
            </template>

            <!--Icon.-->
            <template slot="toggle-children-icon" slot-scope="headers">
                <v-icon v-if="headers.expanded">mdi-menu-down</v-icon>
                <v-icon v-else>mdi-menu-right</v-icon>
            </template>

            <!--Tree Content-->
            <template v-for="column in headers"
                      :slot="column.property"
                      slot-scope="headers">
                <!--Icon.-->
                <v-icon v-if="(headers.row._children.length == 0 && headers.row._meta.parent == 0 && column.tree) || (formData.indexOf(headers.row) == -1 && column.tree)" class="tree-base-node" v-bind:class="{ 'child-node-icon': (formData.indexOf(headers.row) == -1 && column.tree)}">mdi-menu-right</v-icon>
                <!--Content-->
                <span v-if="column.render" :class="_ttChildern(headers.row)"><a v-on:click="_ttSelectionChanged(column.property, headers.row)">{{headers.row[column.property]}}</a></span>
                <span v-else-if="column.value !='ButtonAction'"> {{headers.row[column.property]}}</span>
                <!--Buttons-->
                <span class="tree-table-buttons" v-if="column.value =='ButtonAction'">
                    <v-icon v-if="permissions.indexOf('E') >= 0 && hideButtons.indexOf('Edit') == -1" small class="mr-2 tree-table vue-table-edit" @click="_ttEdit(headers.row)" :title="$t('Edit')"> edit </v-icon>
                    <v-icon v-if="permissions.indexOf('D') >= 0 && hideButtons.indexOf('Delete') == -1" small class="mr-2 tree-table vue-table-delete" @click="_ttDelete(headers.row)" :title="$t('Delete')"> delete </v-icon>
                </span>
            </template>
        </vue-ads-table>
    </div>
</template>

<script>
    import VueAdsTable from 'vue-ads-table-tree';

    /*
        * Component's properties and events
    */
    export default {
        components: {
            VueAdsTable
        },

        /*
            *  A component’s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
            *  this.$options.parent.fileName - current componets name
        */
        data() {
            return this.$store.state[this.$options.parent.fileName];
        },

        /*
            * Define methods under the `methods` object
            * _ttFilterChanged
            * _ttSelectionChanged
            * _ttChildern
        */
        methods: {
            /*
                * Tree table - Execute this function if the filter is changed. It will emit and filter-change and page-change event.
            */
            _ttFilterChanged(filter) {
                this.filter = filter;
            },
            
            /*
                * Tree table - Trigger selection change event.
            */
             _ttSelectionChanged(fieldName, item) {
                let context = this.$store.state[this.$options.parent.fileName];
                this.$store.dispatch(context.fileName + '/selectionChanged', { fieldName,  item });
            },

            /*
               * Tree table - add childern ui.
           */
            _ttChildern(row) {
                let context = this.$store.state[this.$options.parent.fileName];

                if (context.formData.indexOf(row) == -1)
                    return 'tree-child-node';
            },

            /*
                * Data table - Shows edit form for a row.
            */
            _ttEdit(item, fieldName) {
                let context = this.$store.state[this.$options.parent.fileName];

                //#.Add form are triggered with the store.dispatch method.
                this.$store.dispatch('_dtEdit', { context: context, self: this, item: item, fieldName: fieldName });
            },

            /*
                *  Data table - This method is used to delete row from server and the table.
            */
            _ttDelete(item) {
                let context = this.$store.state[this.$options.parent.fileName];

                //#.Add form are triggered with the store.dispatch method.
                this.$store.dispatch('_dtDelete', { context: context, self: this, item: item, name: this.$options.parent.fileName });
            }
        },

        /*
            * Computed Properties
            * _ttFilterChanged
        */
        computed: {
            /*
                *  Execute this function if the filter is changed. It will emit and filter-change and page-change event.
            */
            _ttFilterValue() {
                return "";
            }
        }
    };
</script>

